import React from 'react';
export function Footer() {
  return <footer className="w-full bg-ink-deep text-white" data-id="element-100" data-mp="32wd2qgad7ltj">
      <div className="max-w-3xl mx-auto px-5 py-12 text-center" data-id="element-101" data-mp="3gfsp4jdu96q5">
        <h3 className="font-display text-2xl font-extrabold tracking-tight text-white" data-id="element-102" data-mp="3gh3rcermy6f5">
          Rec Gymnastics <span className="text-amber" data-id="element-103" data-mp="32m1et8sa9itd">Class-Ready</span>
        </h3>
        <p className="mx-auto mt-2 max-w-md text-sm text-white/70" data-id="element-104" data-mp="36pzeplpfmxnh">
          A full year of done-for-you lesson plans &amp; skill progressions — walk into every class ready.
        </p>

        <div className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-1 text-[13px] text-white/70" data-id="element-105" data-mp="37fvf8oqf24t">
          <a href="mailto:help@iclcollective.com" className="inline-flex min-h-[44px] items-center px-1 hover:text-white hover:underline" data-id="element-106" data-mp="3ldu4at858lwc">
            help@iclcollective.com
          </a>
        </div>

        <p className="mx-auto mt-7 max-w-2xl border-t border-ink-line pt-5 text-xs leading-relaxed text-white/45" data-id="element-107" data-mp="29xm0kogz74j3">
          Rec Gymnastics Class-Ready is a class-planning resource for recreational
          gymnastics coaches. It is not affiliated with or endorsed by USA
          Gymnastics, British Gymnastics, Gymnastics Canada, Gymnastics Australia
          or any other governing body. It does not replace coach certification,
          safeguarding or background-check requirements, first-aid training, or
          your club&apos;s and federation&apos;s standards on safety, spotting and
          equipment. Skills are kept within recreational scope. Results depend on
          the coach and the group; no specific outcome is guaranteed. © Rec
          Gymnastics Class-Ready 2026 — All rights reserved.
        </p>
      </div>
    </footer>;
}